import { Button } from '@/components/Button';
import Datagrid from '@/components/Datagrid';
import Card from '@/components/Card';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { type GridColDef } from '@mui/x-data-grid';
import { Plus } from 'lucide-react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
//import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function Security() {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const rows = [
    {
      id: 1,
      protocol: 'TCP',
      ip: '192.168.0.10',
      input: 80,
      output: 8080,
      activated: true,
    },
    {
      id: 2,
      protocol: 'UDP',
      ip: '192.168.0.20',
      input: 53,
      output: 53,
      activated: false,
    },
    {
      id: 3,
      protocol: 'TCP',
      ip: '10.0.0.5',
      input: 22,
      output: 2222,
      activated: true,
    },
    {
      id: 4,
      protocol: 'TCP/UDP',
      ip: '172.16.1.100',
      input: 443,
      output: 4443,
      activated: true,
    },
    {
      id: 5,
      protocol: 'UDP',
      ip: '192.168.100.1',
      input: 5000,
      output: 5001,
      activated: false,
    },
  ];

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', flex: 0.3 },
    {
      field: 'protocol',
      headerName: t('equipment.security.protocol'),
      flex: 0.8,
    },
    { field: 'ip', headerName: 'IP', flex: 1 },
    { field: 'input', headerName: t('equipment.security.inputPort'), flex: 1 },
    {
      field: 'output',
      headerName: t('equipment.security.outputPort'),
      flex: 1,
    },
    {
      field: 'active',
      headerName: t('equipment.security.activated'),
      flex: 0.6,
      renderCell: (params) => <Switch checked={params?.row?.activated} />,
    },
  ];

  return (
    <Stack direction={isMd ? 'column' : 'row'} gap="48px">
      <Card sx={{ maxWidth: isMd ? '100%' : '60%' }}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '16px',
          }}
        >
          <Typography variant="h2">Firewall</Typography>
          <Button>
            <Plus />
            {t('equipment.security.add')}
          </Button>
        </div>
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
          <Datagrid columns={columns} rows={rows} />
        </Box>
      </Card>

      <Card sx={{ maxWidth: isMd ? '100%' : '40%', width: '100%' }}>
        <Typography variant="h2">
          {t('equipment.security.webManagement')}
        </Typography>
        <Box>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography>{t('equipment.security.remoteManagement')}</Typography>
            <Switch />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography>{t('equipment.security.httpsManagement')}</Typography>
            <Switch />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography>{t('equipment.security.activeICMP')}</Typography>
            <Switch />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Typography>
              {t('equipment.security.changeAccessPassword')}
            </Typography>
            <Button>{t('equipment.security.changePassword')}</Button>
          </div>
        </Box>
      </Card>
    </Stack>
  );
}

export default Security;
